import { isNumber } from "lodash";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { colors } from "../colors";
import styles from "./enter_guests_number_step.module.css";

interface EnterGuestsNumberStepProps {
  onNext: (numberOfGuests: number) => void;
  maxOfGuests: number;
  value?: number;
}

export function EnterGuestsNumberStep({
  onNext,
  maxOfGuests,
  value,
}: EnterGuestsNumberStepProps) {
  const [numberOfGuests, setNumberOfGuests] = useState(value);
  const isOverMaxNumber =
    isNumber(numberOfGuests) && numberOfGuests > maxOfGuests;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const number = Number(value);
    if (value === "" || number < 0) {
      setNumberOfGuests(undefined);
    } else {
      setNumberOfGuests(Number(value));
    }
  };

  return (
    <div>
      <div className="mt-2 position-relative">
        <input
          type="number"
          min={0}
          className={`rounded w-100 px-3 py-2 ${styles.input}`}
          placeholder="Number of guests"
          value={numberOfGuests}
          onChange={handleChange}
          style={{
            borderColor: isOverMaxNumber ? colors.grapefruit20 : "#e0e0e0",
          }}
          data-testid="event-space-enter-number-of-guests-input"
        />
        <div
          className="position-absolute top-50 end-0 translate-middle "
          style={{ color: "#B2B2B2" }}
        >
          /{maxOfGuests}
        </div>
      </div>
      {isOverMaxNumber && (
        <div
          style={{ color: colors.grapefruit20, fontSize: 14 }}
          className="mt-1"
        >
          Your expected number of guests exceeds the capacity of the layout you
          selected.
        </div>
      )}
      <Button
        variant="outline-primary"
        className="mt-3 p-2"
        disabled={!numberOfGuests || isOverMaxNumber}
        onClick={() => numberOfGuests && onNext(numberOfGuests)}
        data-testid="event-space-enter-number-of-guests-next-step"
      >
        Next step
      </Button>
    </div>
  );
}
